import { Caption } from '@remotion/captions';
import React, { useMemo } from 'react';

export const StaticWord: React.FC<{
  readonly item: Caption;
  readonly frame: number;
  readonly transcriptionColor: string;
}> = ({ item, frame, transcriptionColor }) => {
  const style: React.CSSProperties = useMemo(() => {
    return {
      display: 'inline-block',
      whiteSpace: 'pre',
      color: transcriptionColor,
    };
  }, [transcriptionColor]);

  return <span style={style}>{item.text}</span>;
};
